import { DAY_NAMES, MONTH_NAMES, SHORT_DAY_NAMES, SHORT_MONTH_NAMES, KEY_API_CHANGE_COLOR } from "../constant/common";
import { number } from "@euroland/format-number";
import {dayjs, i18n, isValidNegativeNumberFormat, loadCustomStylesheet, setVariableByTemplate } from "@euroland/libs";

import variableStyles from "../styles/variables-style.json";
import variableStylesCommon from "@euroland/react-utils/dist/styles/variables-style.json";


export function getLanguage() {
  var locale = window.appSettings?.language;
  if (!locale || !locale.length) {
    locale = "en-gb";
  }
  return locale;
}

/**
 *
 * @param { number | Date} value
 * @param { import('../..').CompanySetting } settings
 * @returns { import('dayjs').Dayjs }
 */
export function getDateTime(value, settings) {
  let timeZone = settings.timezone;
  return dayjs.utc(value).tz(timeZone);
}

/**
 *
 * @param { number | Date} value
 * @param { string} typeDate // shortDate || longDate
 * @param { import('../..').FormatSetting } settings
 * @returns { string }
 */
export function formatDateTime(value, settings, typeDate) {
  value = value || new Date();
  let formatDate =typeDate === 'shortDate' ? settings.shortDate : settings.longDate;
  let timeZone = settings.timezone;
  return dayjs.utc(value).tz(timeZone).format(formatDate);
}

/**
 *
 * @param { number | Date} value
 * @param { string} typeDate // shortDate || longDate
 * @param { import('../..').FormatSetting } settings
 * @returns { string }
 */
export function formatDateApi(value) {
  value = value || new Date();
  var dateString = `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`;
  return dayjs.utc(dateString).toISOString();
  // return dayjs.utc(dateString).format();
}

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting } param1
 * @returns { string }
 */
export function formatNumber(value, { decimalDigits, decimalSeparator, thousandSeparator }) {
  var dec_point = decimalSeparator,
    thousands_sep = thousandSeparator;
  value = (value + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+value) ? 0 : +value,
    prec = !isFinite(+decimalDigits) ? 0 : Math.abs(decimalDigits),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting} format
 * @returns
 */
export function convertNumber(value, format) {
  return formatNumber(value, { ...format, decimalDigits: 0 });
}

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting } format
 * @returns { string }
 */
export function convertNumberDecimal(value, format) {
  if (value < 0) {
    let numberFormated = formatNumber(Math.abs(value), format);
    return formatNegativeNumber(numberFormated, format.negativeNumberFormat);
  }
  return formatNumber(value, format);
}

/**
 *
 * @param { string } stringValue
 * @param { import("../..").INegativeNumberFormat } formatNegativeNumber
 * @returns { string }
 */
export function formatNegativeNumber(stringValue, formatNegativeNumber) {
  if (!isValidNegativeNumberFormat(formatNegativeNumber)) {
    formatNegativeNumber = "-n";
  }
  return formatNegativeNumber.replace("n", stringValue);
}


// TODO
export function loadSettingEUCalendar(params = {}, settings) {
  const { language, isRtl, translations, dateNames: dateNamesJSON,  } = window.appSettings;

  let {useLatinNumber} = settings.data.settings;
  if (window.appSettings.language !== "ar-ae" ) useLatinNumber = true
  const dateNames = JSON.parse(dateNamesJSON);
  const mn = dateNames?.monthNames ? dateNames.monthNames.filter(m => !!m) : MONTH_NAMES;
  const smn = dateNames?.shortMonthNames ? dateNames.shortMonthNames.filter(m => !!m) : SHORT_MONTH_NAMES;
  const dn = dateNames?.dayNames ? dateNames.dayNames.filter(m => !!m) : DAY_NAMES;
  const sdn = dateNames?.shortDayNames ? dateNames.shortDayNames.filter(m => !!m) : SHORT_DAY_NAMES;
  window.Calendar.LANG(language || "en", language || "English", {
    fdow: 1, // first day of week
    goToday: translations["today"] || "Today",
    today: translations["today"] || "Today",
    closeBtn: translations["close"] || "Close",
    selectedDate: translations["selectedDate"] || "selected",
    wk: "wk",
    weekend: "0,6",
    AM: translations["AM"],
    PM: translations["PM"],
    nextMonth: translations["nextMonth"],
    prevMonth: translations["prevMonth"],
    nextYear: translations["nextYear"],
    prevYear: translations["prevYear"],
    description: translations["description"],
    year: translations["year"],
    yearPeriod: translations["yearPeriod"] || "${minYear}-${maxYear}",
    mn,
    smn,
    dn,
    sdn,
    isRtl,
    useArabicNumeral: !useLatinNumber,
    ...params,
  });

  return settings
}

export const sortOrderData = (orderArray = [], instrument = {}) => {
  // const newOrderArray = [];
  // instrument.forEach(id => {
  //   const findItem = orderArray.find(x => x.instrumentId === id);
  //   if (findItem) newOrderArray.push(findItem)
  // })
  const newOrderArray = orderArray.sort((a,b) => {
      return instrument[a.instrumentId].order - instrument[b.instrumentId].order
    });

    return newOrderArray
}

/**
 *
 * @param {number} decimalDigits
 * @returns { string }
 */
export const transitionDecimalDigitsToFormatNumber = (decimalDigits) => {
  let formatNumber = "#,##0.";
  for (let i = 1; i <=decimalDigits; i++ ) {
    formatNumber += '0'
  }
  return formatNumber
}
export function isString(item) {
  return Object.prototype.toString.call(item) === "[object String]";
}



export function loadConfiguredCustomStylesheet(settings) {
  loadCustomStylesheet(window.appSettings.customStylesheets, settings.data.settings.styleURI, window.appSettings.customStylesheetUrlBase);
  return settings;
}

export function loadVariableStylesByTemplate(settings) {
  const template = settings.data.settings.template;
  setVariableByTemplate(template, variableStylesCommon, variableStyles).injectTo(document.head, true);
  return settings;
}

// Display value table in share-price tab
export const renderValueTable = (keyApi, dataValue) => {
  if (dataValue.isNullAllData || dataValue[keyApi] === null) return i18n.translate("textNoData");
  // if (keyApi === 'currency') return getCurrencyLabel(dataValue[keyApi]);
  if (["highestVolume", "lowestVolume"].includes(keyApi))
    return number(dataValue[keyApi], transitionDecimalDigitsToFormatNumber(0));
  return `${number(dataValue[keyApi])} ${KEY_API_CHANGE_COLOR.includes(keyApi) ? "%" : ""}`;
};

// Search min startingDate of instrument
/**
 *
 * @param {Object} instruments
 * @param {Object} selectedInstrumentId
 * @returns { Date }
 */
 export const findMinStartingDate = (instruments = {}, selectedInstrumentId = {}) => {
  const selectedInstrumentArr = []
  for (let i in selectedInstrumentId) {
    selectedInstrumentArr.push(instruments[i])
  }

  let minStartingDate = ''
  selectedInstrumentArr.forEach(item => {
    const startingDate = item.startingDate;
    if (!minStartingDate) minStartingDate = startingDate;
    else {
      let minDate = new Date(minStartingDate).getTime();
      let currentDate = new Date(startingDate).getTime();
      if (currentDate < minDate) minStartingDate = startingDate
    }
  })
  return minStartingDate
}

/**
 *
 * @param {number} value
 * @returns { number }
 */
 export const convertArabicNumber = (value) => value.toLocaleString('ar-AE')


 /**
 *
 * @param {Array} array
 */
export const findLatestDate = array => {
  let latestDate = null;

  for (const item of array) {
    const currentDate = dayjs(item.latestDate);

    if (!latestDate || currentDate.isAfter(latestDate)) {
      latestDate = currentDate;
    }
  }

  return dayjs(latestDate);
};


 export {
  classNames,
  pickBy,
  replaceKey,
  mergeObject,
  observerWindowResize,
  clickWithoutMove,
  getRealEventName,
  getRandomString,
  stringId,
  compareSameKeyObject,
  objectToEnum,
  compareDate,
  checkEmptyObject,
  convertToJson,
} from "@euroland/libs";
